import { render } from "./MyCloseButton.vue?vue&type=template&id=7b00fafe&scoped=true"
import script from "./MyCloseButton.vue?vue&type=script&lang=js"
export * from "./MyCloseButton.vue?vue&type=script&lang=js"

import "./MyCloseButton.vue?vue&type=style&index=0&id=7b00fafe&scoped=true&lang=css"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b00fafe"]])

export default __exports__